import { Subject, Observable } from 'rxjs';

export class CustomModalRef<RESULT = any> {
  private readonly _afterClosed = new Subject<RESULT | undefined>();

  constructor(private portalHost: HTMLElement, private backdropHost: HTMLElement, private disableClose: boolean) {}

  /** Returns an observable that emits once the modal closes. */
  afterClosed(): Observable<RESULT | undefined> {
    return this._afterClosed.asObservable();
  }

  /** Programmatically close the modal and optionally pass a result. */
  close(result?: RESULT): void {
    this._afterClosed.next(result);
    this._afterClosed.complete();
    this.dispose();
  }

  /** Destroy overlay elements. */
  dispose(): void {
    document.body.style.overflow = this._originalOverflow ?? '';
    if (this.backdropHost.parentNode) {
      this.backdropHost.parentNode.removeChild(this.backdropHost);
    }
    if (this.portalHost.parentNode) {
      this.portalHost.parentNode.removeChild(this.portalHost);
    }
  }

  // ----- internal ----- //
  private _originalOverflow = '';
  _saveOverflow(): void {
    this._originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
}